const trayLayout = (settings) =>  {
   return {
    "fontSetting": settings?.fontSettings?.[0],
    "settings": {
        "columns": settings?.columns,
        "thumbnailPlacement": settings?.thumbnailPlacement,
        "thumbnailType": settings?.thumbnailType,
        "showMonetizationBadge": settings?.showMonetizationBadge,
        "showBadgeOnThumbnail": settings?.showBadgeOnThumbnail,
        "showMonetizationBadgeOnThumbnail": settings?.showMonetizationBadgeOnThumbnail
    },
}
}
export {trayLayout}